var RecaptchaSiteKey = '6LfsVy0fAAAAAFLAJ4P7FMMXDCJrdl6OS6E1DNVL';
var EnableRecaptcha = true;
var EnableTranslation = true;

module.exports = {
    EnableRecaptcha,
    RecaptchaSiteKey,
    EnableTranslation
}
